import { Image } from 'lib-core'


export default Image
